
export enum API_URL {
  ADVISOR_NUTANIX = "/api/menu/v1/page/nutanix/advisor",
  ADVISOR_POWER = "/api/menu/v1/page/power/advisor",
  ADVISOR_PROXMOX = "/api/menu/v1/page/proxmox/advisor",
  ADVISOR_VMWARE = "/api/menu/v1/page/vmware/advisor",
  ADVISOR_KUBERNETES = "/api/menu/v1/page/kubernetes/advisor",
  ADVISOR_OVIRT = "/api/menu/v1/page/ovirt/advisor",
  ADVISOR_WINDOWS = "/api/menu/v1/page/windows/advisor",
  ADVISOR_LINUX = "/api/menu/v1/page/linux/advisor",
  ALERTING = '/api/alerting/v1',
  ALERTING_INTEGRATIONS = '/api/alerting/v1/integrations/',
  ARCHITECTURE = '/api/architecture/v1',
  CONFIGURATION = '/api/configuration/v1',
  CUSTOM_GROUP = '/api/custom_group/v1',
  CUSTOM_GROUPS = '/api/custom_group/v1/custom_groups',
  CUSTOM_GROUP_MENU = '/api/custom_group/v1/menu',
  CUSTOM_GROUP_MENU_GROUP = '/api/custom_group/v1/menu/groups',
  DASHBOARD = '/api/dashboard/v1',
  DASHBOARD_GROUP = '/api/dashboard/v1/group',
  DASHBOARD_FIND_ITEM = '/api/dashboard/v1/item/find',
  DASHBOARD_GRAFANA = '/api/dashboard/v1/grafana',
  DASHBOARD_ITEM = '/api/dashboard/v1/item',
  DASHBOARD_MENU = '/api/dashboard/v1/menu',
  DASHBOARD_MENU_GROUP = '/api/dashboard/v1/menu/groups',
  DASHBOARD_CUSTOM_GRAPH = '/api/dashboard/v1/custom_graph',
  DASHBOARD_CUSTOM_GRAPHS = '/api/dashboard/v1/custom_graphs',
  DASHBOARD_TREE = '/api/dashboard/v1/tree',
  EMAIL_GROUPS = '/api/configuration/v1/mail_groups',
  EXPORTER = '/api/exporter/v1/exports',
  FABRIC = '/api/configuration/v1/fabric',
  GROUPS_FOLDER = '/api/folder_group/v1/folder',
  GROUPS_FOLDERS = '/api/folder_group/v1/folders',
  HEATMAP = '/api/heatmap/v1',
  HEALTH = '/api/health/mailgroups',
  INFO = '/api/info',
  LICENSE = '/api/configuration/v1/license',
  LLM = '/api/llm/v1',
  LOG_ERR = '/api/log/ui',
  MENU = '/api/menu/v1',
  MENUGROUP = '/api/configuration/v1/menugroup',
  METRICS = '/api/metrics/v1',
  MICROSERVICES = '/api/microservices',
  OIDC = '/api/oidc/v1',
  OS_AGENT = '/api/menu/v1/page/linux/status',
  SELF_MONITORING = '/api/configuration/v1/monitoring',
  SESSION = '/api/session/v1',
  STORAGE_GROUPS = '/api/menu/v1/folder/sgroups',
  STORAGE_GROUP_GROUPS = '/api/menu/v1/folder/group_sgroups',
  STORAGE_GROUPS_EDIT = '/api/storage_group/v1',
  STORAGE_GROUPS_FOLDER = '/api/storage_group/v1/folder',
  SERVER_GROUPS = '/api/server_groups/v1',
  SERVER_GROUPS_FOLDER = '/api/menu/v1/folder/servergroups',
  TAG = '/api/tag/v1',
  TOKEN = '/api/token/v1',
  USER = '/api/users/v1/user',
  VENDORS = '/api/vendors/v1',
  ZABBIX_INTEGRATIONS = '/api/alerting/v1/zabbix-integrations',
  ZABBIX_INTEGRATION = '/api/alerting/v1/zabbix-integration',
}
